// ResetPassword.js
import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Button,
  FormControl,
  Input,
  Box,
  useToast,
  Text,
  Flex,
  Image,
} from '@chakra-ui/react';
import './App.css';

const ResetPassword = () => {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || '');
  const toast = useToast();

  const handleResetRequest = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/request-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (response.ok) {
        toast({
          title: 'Reset Link Sent',
          description: data.message,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: 'Error',
          description: data.error,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex className="start-container" direction={{ base: 'column', md: 'row' }}>
      <Box flex="1.5" pr="5%">
        <Image src="/images/pablo_logo1.0.svg" alt="Logo" boxSize="48px" mb="5%" />
        <Text fontSize="9xl" fontWeight="Normal" mb={6}>
          Reset Password
        </Text>
        <Text fontSize="4xl" fontWeight="normal" mb="2%" lineHeight={1.1}>
          Enter your email and we'll send you a link to reset your password.
        </Text>
      </Box>

      <Box className="container-box" flex="1" mt={24}>
        <form onSubmit={handleResetRequest} className="fed-form">
          <FormControl mb={4}>
            <Input
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="fed-input"
            />
          </FormControl>
          <Button colorScheme="blue" type="submit" width="100%" className="fed-button">
            Send Reset Link
          </Button>
          <Flex mt={6}>
            <Text fontSize="sm" mr={4}>Remember your password?</Text>
            <Box>
              <Link to="/login" className="back-home-link">Back to Login</Link>
            </Box>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
};

export default ResetPassword;
